import React from 'react';
import { useSelector } from 'react-redux';
import { Table } from 'react-bootstrap';

function Reports() {
  const { holdings, transactions, portfolioValue, profitOrLoss } = useSelector((state) => state.account);

  return (
    <div>
      <h2>Reports</h2>
      <Table striped bordered hover className='mt-3'>
        <thead>
          <tr>
            <th>Symbol</th>
            <th>Shares</th>
            <th>Total Value</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(holdings).map(([symbol, shares]) => (
            <tr key={symbol}>
              <td>{symbol}</td>
              <td>{shares}</td>
              <td>${(shares * 100).toFixed(2)}</td> {/* Assume a fixed price for demonstration */}
            </tr>
          ))}
        </tbody>
      </Table>
      <h3>Total Portfolio Value: ${portfolioValue}</h3>
      <h3>Profit/Loss: ${profitOrLoss}</h3>
    </div>
  );
}

export default Reports;
